import { Injectable } from '@angular/core';
import { trackEvent } from '@intercom/messenger-js-sdk';
import { AuthenticationService } from 'src/app/auth/authentication.service';

/** Event names match the Intercom event list. */
export const INTERCOM_EVENT = {
  JO_CREATED: 'JO Created',
  ASSET_CREATED: 'Asset Created',
  SPARE_PART_ADDED_TO_JO: 'Spare Part Added To JO',
};

@Injectable({
  providedIn: 'root',
})
export class IntercomService {
  constructor(private auth: AuthenticationService) {}

  /**
   * Send an event only when Intercom is booted for this tenant.
   * A failed call must not block the save the user just finished.
   */
  track(event: string): void {
    try {
      const features = this.auth.getAddonFeatureLists();
      const enabled =
        features?.addonINTERCOM == 'INTERCOM' || features?.addonONBOARD == 'ONBOARD';
      if (!enabled) {
        return;
      }
      trackEvent(event);
    } catch (err) {
      console.error('Intercom trackEvent failed', event, err);
    }
  }
}
